var _style, _g, _defs, _defs2, _rect, _defs3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRichiesteNessunDatoCreato(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 75",
    style: {
      enableBackground: "new 0 0 100 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E4EAF1;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{display:inline;clip-path:url(#SVGID_2_);}\n\t.st4{clip-path:url(#SVGID_4_);fill:#004B71;}\n\t.st5{display:inline;clip-path:url(#SVGID_6_);fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,9.4v56.2c0,5.2-4.2,9.4-9.4,9.4H9.4C4.2,75,0,70.8,0,65.6V9.4C0,4.2,4.2,0,9.4,0h81.2 C95.8,0,100,4.2,100,9.4z M9.4,9.4v8c4.4,3.6,11.4,9.1,26.3,20.8c3.3,2.6,9.8,8.8,14.3,8.7c4.5,0.1,11-6.1,14.3-8.7 c14.9-11.7,21.9-17.2,26.3-20.8v-8H9.4z M90.6,65.6V29.4c-4.5,3.6-10.8,8.6-20.5,16.1C65.7,49,58.3,56.3,50,56.2 c-8.4,0-15.9-7.4-20.1-10.7c-9.7-7.6-16-12.6-20.5-16.1v36.3H90.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 92,
    cy: 75,
    r: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -691,
    y: -540,
    width: 1440,
    height: 1100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 46,
    className: "st4",
    width: 58,
    height: 58
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 69,
    y: 50,
    width: 47,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.1,82.3c0.2,0.2,0.2,0.4,0,0.6l-1.2,1.2c-0.2,0.2-0.4,0.2-0.6,0L98.1,83l-5.6-5.6l-6.8,6.8 c-0.2,0.2-0.4,0.2-0.6,0l-1.2-1.2c-0.2-0.2-0.2-0.4,0-0.6l6.8-6.8l-6.8-6.8c-0.2-0.2-0.2-0.4,0-0.6l1.2-1.2c0.2-0.2,0.4-0.2,0.6,0 l6.8,6.8l6.8-6.8c0.2-0.2,0.4-0.2,0.6,0l1.2,1.2c0.2,0.2,0.2,0.4,0,0.6l-1.2,1.2l-5.6,5.6L101.1,82.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichiesteNessunDatoCreato);
export default __webpack_public_path__ + "static/media/richieste-nessun-dato-creato.4567dac9d6ae8a16852e13b4637b60c0.svg";
export { ForwardRef as ReactComponent };